<span class="inline-flex text-center items-center rounded-base px-2 py-1 font-medium text-xs" [ngClass]="{
        'bg-green-100 text-success ring-green-100': badgeType === 'success',
        'bg-red-100 text-danger ring-red-300': badgeType === 'danger',
        'bg-yellow-100 text-yellow-800 ring-yellow-300': badgeType === 'pending',
        'bg-blue-100 text-blue-800 ring-blue-300': badgeType === 'info',
        'bg-gray-100 text-gray-800 ring-gray-300': badgeType === 'default'
  }">
  {{badgeText}}
</span>
